import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { IxellAPIService } from './api.service';
import { ErrorService } from './error.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService implements OnInit, OnDestroy {
  products: any[] = [];
  constructor(private router: Router, private apiService: IxellAPIService, private errorService: ErrorService) { }

  ngOnInit() { }

  ngOnDestroy() { }

  redirect() {
    if (this.get("token") == null) {
      this.router.navigate(['/']);
    } else {
      this.verifyRole(this.get("role"));
    }
  }

  setProducts(prod: string, qte: string) {
    let obj = { produit: prod, quantite: qte };
    this.products.push(obj);
  }

  verifyRole(role: string) {
    this.apiService.verifyRole(role).subscribe(data => {
      return data;
    }, error => {
      this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "verifyRole", new Date().toString());
      console.log(error);
    })
  }

  get(name: string): string {
    return sessionStorage.getItem(name);
  }

  set(name: string, tokenValue: string): void {
    sessionStorage.setItem(name, tokenValue);
  }

  remove(name: string) {
    sessionStorage.removeItem(name);
  }

}
